// GoAlert GraphQL API Key (backstage-readonly) is AST-locked to exactly the
// four operations below — sending any other operation, or even one of these
// operations in isolation, returns `wrong query for API key`. Submit the
// full document as `query` and use `operationName` to pick which to run.
//
// This document is verbatim from the heystaq handover (2026-05-24). If
// heystaq rotates the key or extends the allowed operations, this file gets
// updated; the operations cannot be added to without coordinating with the
// heystaq team because the key is operation-scoped on their side.
// GoAlert on-call card — two service UUIDs the card queries. NOT secrets
// — they're stable identifiers heystaq provides for the Aknostic on-call
// rotation, one per severity. The actual credential (GraphQL API key) lives
// in the SOPS-encrypted backstage-goalert Secret and is injected into the
// proxy server-side.
//
// Hardcoded as TS constants rather than app-config because Backstage 1.50's
// frontend-bundle config filtering doesn't consistently respect the app
// package's own configSchema — plugin packages work, the app package's
// declaration was ignored across two attempts (commits 9ec3192 and e2146de).
// Per-environment flexibility wasn't materially valuable here (one Backstage
// instance, one set of UUIDs); revisit if we ever stand up a second
// Backstage tenant.
export const CRITICAL_SERVICE_ID = 'b4f8a964-0260-4663-ad0c-af905d0bf846';
export const NON_CRITICAL_SERVICE_ID = '877a56e9-3aea-4d54-a6ca-5aa9af2f6195';

export const GOALERT_QUERY_DOCUMENT = `query BackstageServiceOnCall($serviceID: ID!) {
  service(id: $serviceID) {
    id
    name
    description
    onCallUsers {
      userID
      userName
      stepNumber
    }
    escalationPolicy {
      id
      name
      description
      steps {
        delayMinutes
        targets {
          id
          name
          type
        }
      }
    }
  }
}

query BackstageEscalationPolicy($policyID: ID!) {
  escalationPolicy(id: $policyID) {
    id
    name
    description
    steps {
      delayMinutes
      targets {
        id
        name
        type
      }
    }
  }
}

query BackstageSchedule($scheduleID: ID!) {
  schedule(id: $scheduleID) {
    id
    name
    description
    timeZone
  }
}

query BackstageAlerts($serviceID: ID!, $limit: Int) {
  alerts(input: {filterByServiceID: [$serviceID], first: $limit}) {
    nodes {
      id
      alertID
      status
      summary
      createdAt
      service {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
`;

export type EscalationTarget = {
  id: string;
  name: string;
  type: string;
};

export type EscalationStep = {
  delayMinutes: number;
  targets: EscalationTarget[];
};

export type OnCallUser = {
  userID: string;
  userName: string;
  stepNumber: number;
};

export type ServiceOnCall = {
  id: string;
  name: string;
  description?: string;
  onCallUsers: OnCallUser[];
  escalationPolicy: {
    id: string;
    name: string;
    description?: string;
    steps: EscalationStep[];
  };
};
